import { handleReIssueAccessToken } from "./handleReIssueAccessToken";
import { showAlert } from "@erp/shared/utils/dialog";
import { clearAccessToken, clearRefreshToken, } from "@erp/shared/utils/auth/token";
export async function handle401Error(error, originalConfig) {
    const errorCode = error.response?.data?.code || "unknown_error";
    // Access Token 만료인 경우에만 갱신 시도
    if (errorCode === "AUTH_ACCESS_TOKEN_EXPIRED") {
        return await handleReIssueAccessToken(error, originalConfig);
    }
    if (errorCode === "AUTH_TOKEN_REVOKED" ||
        errorCode === "AUTH_MISSING_TOKEN" ||
        errorCode === "AUTH_REFRESH_TOKEN_INVALID") {
        clearAccessToken();
        clearRefreshToken();
        showAlert("로그인이 만료되었습니다. 다시 로그인해주세요.");
        const authError = new Error("로그인이 만료되었습니다. 다시 로그인해주세요.");
        authError.code = errorCode;
        authError.authExpired = true;
        return Promise.reject(authError);
    }
    return Promise.reject(error);
}
